module.exports = __webpack_public_path__ + "static/media/DyAppLogo.e22f454c.png";